import axiosConfig from '../data/utils/axiosConfigInstance';

export const instructorApi = {
	createInstructor: formData => axiosConfig.post('/admin/instructor/create', { ...formData }),
	updateInstructor: (id, formData) => axiosConfig.patch(`/admin/instructor/update/${id}`, { ...formData })
};
